import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'hiring-tool',
  children: {
    candidateAdded: {
      path: 'candidate_added/:id',
    },
    applicationAdded: {
      path: 'application_added/:id/:job_id',
    },
  },
} as const satisfies Location
